import NotificationsIcon from './NotificationsIcon';

export default NotificationsIcon;
